<script lang="ts">
import { defineComponent, computed } from 'vue';
import { any, object } from 'vue-types';

import AddressText from '@/ui/AddressText.vue';
import ActiveInactiveIcon from '@/ui/ActiveInactiveIcon.vue';
import type { SchoolFragmentFragment } from '@/graphql/generated/graphql';

export default defineComponent({
  name: 'SchoolPageTitle',
  components: {
    AddressText,
    ActiveInactiveIcon,
  },
  props: {
    school: object<SchoolFragmentFragment>().isRequired,
    class: any(),
  },
  setup(props) {
    const isActive = computed(() => props.school.school_status === 'active');
    return {
      isActive,
    };
  },
});
</script>
<template>
  <div :class="$props.class">
    <h1 class="text-2xl" style="margin-bottom:0">
      {{ school.school_name }}
    </h1>
    <div class="flex items-center space-x-3 flex-wrap text-sm opacity-50">
      <AddressText
        v-if="school.address1 && school.address_city && school.address_country"
        :record="{
          address1: school.address1,
          address2: school.address2,
          address_city: school.address_city,
          address_state: school.address_state,
          address_zip: school.address_zip,
          address_country: school.address_country,
        }"
      />
      <ActiveInactiveIcon
        class="flex space-x-0.5"
        :status="isActive"
        :text="isActive ? 'Active' : 'Inactive'"
      />
    </div>
  </div>
</template>
